import { createReducer, on } from '@ngrx/store';
import { SearchRecipesState } from '../models/search.model';
import {
  PanelExpansionChanged,
  SchemaSuccess,
  RecipeTypeChanged,
  DeletedChanged,
  ActiveChanged,
  ClearSearchOptions,
  OpenSideNav,
  CloseSideNav,
  EditRecipe,
  StartDateChanged,
  EndDateChanged,
  RecipeNameChanged,
  RecipeTypesSuccess,
  StartDateCleared,
  EndDateCleared,
  RecipeCodesSuccess,
} from '../actions/search.actions';
import { PointSourcesSuccess } from '../actions/registration-points.actions';

const initialState: SearchRecipesState = {
  panelExpanded: true,
  recipeTypes: [],
  recipeCodes: [],
  schemas: [],
  selectedRecipeType: '',
  selectedRecipeName: '',
  selectedStartDate: '',
  selectedEndDate: '',
  active: true,
  deleted: false,
  sideNav: false,
  gridData: null,
  typeHelpText: false,
  nameHelpText: false,
  dateHelpText: false,
  statusHelpText: false,
};

export const SearchRecipesReducer = createReducer(
  initialState,
  on(PanelExpansionChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(RecipeTypesSuccess, (state, { recipeTypes }) => ({
    ...state,
    recipeTypes,
  })),
  on(RecipeCodesSuccess, (state, { recipeCodes }) => ({
    ...state,
    recipeCodes,
  })),
  on(SchemaSuccess, (state, { schemas }) => ({
    ...state,
    schemas,
  })),
  // on(PointSourcesSuccess, (state, { pointSources }) => ({
  //   ...state,
  //   pointSources,
  // })),
  on(RecipeTypeChanged, (state, { selectedRecipeType }) => ({
    ...state,
    selectedRecipeType,
  })),
  on(RecipeNameChanged, (state, { selectedRecipeName }) => ({
    ...state,
    selectedRecipeName,
  })),
  on(DeletedChanged, (state, { deleted }) => ({
    ...state,
    deleted: deleted,
    active: !deleted,
  })),
  on(ActiveChanged, (state, { active }) => ({
    ...state,
    active: active,
    deleted: !active,
  })),
  on(StartDateChanged, (state, { selectedStartDate }) => ({
    ...state,
    selectedStartDate,
  })),
  on(StartDateCleared, (state) => ({
    ...state,
    selectedStartDate: '',
  })),
  on(EndDateChanged, (state, { selectedEndDate }) => ({
    ...state,
    selectedEndDate,
  })),
  on(EndDateCleared, (state) => ({
    ...state,
    selectedEndDate: '',
  })),
  on(ClearSearchOptions, (state) => ({
    ...state,
    selectedRecipeType: '',
    selectedRecipeName: '',
    selectedStartDate: '',
    selectedEndDate: '',
    deleted: false,
    active: true,
  })),
  on(OpenSideNav, (state) => ({
    ...state,
    sideNav: true,
  })),
  on(CloseSideNav, (state) => ({
    ...state,
    sideNav: false,
  })),
  on(EditRecipe, (state, { row }) => ({
    ...state,
    gridData: row,
  })),
);
